import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { CHANGELOG } from "@/content/pages";

const fmt = (d) => new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

export default function Changelog() {
  return (
    <PageShell testid="changelog-root" seo={{
      title: "Changelog — Sema",
      description: "Release notes and product updates for Sema, the semantic layer for enterprise AI.",
      keywords: "sema changelog, release notes, product updates",
      path: "/changelog",
    }}>
      <PageHero testid="changelog-h1" eyebrow="Changelog"
        title="What's new in Sema."
        subtitle="Every meaningful change, in reverse-chronological order." />

      <section className="pb-24">
        <div className="mx-auto w-full max-w-3xl px-6">
          <ol className="relative border-l border-border/60">
            {CHANGELOG.map((e) => (
              <li key={e.version} data-testid={`changelog-${e.version}`} className="ml-6 pb-12 last:pb-0">
                <span className="absolute -left-[7px] mt-1.5 h-3.5 w-3.5 rounded-full border-2 border-background bg-accent" />
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-mono text-lg font-semibold tracking-tight">{e.version}</span>
                  <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">{fmt(e.date)}</span>
                  {e.tags.map((t) => (
                    <span key={t} className="rounded-full bg-accent/12 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.14em] text-accent">{t}</span>
                  ))}
                </div>
                <ul className="mt-4 space-y-2">
                  {e.items.map((it, i) => (
                    <li key={i} className="text-sm leading-relaxed text-muted-foreground">— {it}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </PageShell>
  );
}
